import React from 'react'
import * as UI from 'ui'
import { SpaceBetween } from 'ui'
import * as Displays from 'support/displays'
import { Translation, Translator } from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import { Model } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import ManageRestaurantToGoKpiSmartview from 'widgets/economy/smartviews/ManageRestaurantToGoKpiSmartview'
import KpiRangeValue from 'widgets/economy/partials/KpiRangeValue'
import CookieFilter from "support/filters/CookieFilter";

export default function RestaurantToGoRatioEconomyWidget () {
  return (
    <Widget>
      <Translator namespace='economy.restaurant_to_go'>
        <UI.Card paddingBottom={false}>
          <SpaceBetween>
            <UI.Text weight='medium' size='lg'>
              <Translation name='title' />
            </UI.Text>
            <Can permission={Permissions.FINANCIALS_MANAGE}>
              <MountSmartviewOnClick smartview={<ManageRestaurantToGoKpiSmartview />} replace={false}>
                <UI.SquareButton color='lightgray'>
                  <UI.Icons.Settings />
                </UI.SquareButton>
              </MountSmartviewOnClick>
            </Can>
          </SpaceBetween>

          <Model resourceName='economy' operationName='restaurant_to_go_ratio'>
            <CookieFilter name='period' cookieKey='page.filters.period' />
            <SelectedDepartmentFilter />

            <div className='flex flex-col flex-grow flex-shrink mt-12'>

              <SmartviewTextGroup>

                <SmartviewText>
                  <UI.Text size='base' color='black'>
                    <Translation name='beverages' />
                  </UI.Text>
                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <Translation name='restaurant_per_guest' />
                    </UI.Text>

                    <SmartviewTextGroup>
                      <KpiRangeValue
                        name='beverages.restaurant_per_guest'
                        lowerLimitName='indicators.beverages_per_guest_restaurant_lower_limit'
                        upperLimitName='indicators.beverages_per_guest_restaurant_upper_limit'
                      >
                        <UI.Text weight='medium' size='base' align='right' color='black'>
                          <Displays.Number name='beverages.restaurant_per_guest' />
                        </UI.Text>
                      </KpiRangeValue>
                    </SmartviewTextGroup>
                  </UI.SpaceBetween>

                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <Translation name='to_go_per_guest' />
                    </UI.Text>

                    <SmartviewTextGroup>
                      <KpiRangeValue
                        name='beverages.to_go_per_guest'
                        lowerLimitName='indicators.beverages_per_guest_takeaway_lower_limit'
                        upperLimitName='indicators.beverages_per_guest_takeaway_upper_limit'
                      >
                        <UI.Text weight='medium' size='base' align='right' color='black'>
                          <Displays.Number name='beverages.to_go_per_guest' />
                        </UI.Text>
                      </KpiRangeValue>
                    </SmartviewTextGroup>
                  </UI.SpaceBetween>
                </SmartviewText>

                <SmartviewContentSeparator className='my-4' />

                <SmartviewText>
                  <UI.Text size='base' color='black'>
                    <Translation name='food' />
                  </UI.Text>
                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <Translation name='restaurant_per_guest' />
                    </UI.Text>

                    <SmartviewTextGroup>
                      <KpiRangeValue
                        name='food.restaurant_per_guest'
                        lowerLimitName='indicators.items_per_guest_restaurant_lower_limit'
                        upperLimitName='indicators.items_per_guest_restaurant_upper_limit'
                      >
                        <UI.Text weight='medium' size='base' align='right' color='black'>
                          <Displays.Number name='food.restaurant_per_guest' />
                        </UI.Text>
                      </KpiRangeValue>
                    </SmartviewTextGroup>
                  </UI.SpaceBetween>

                  <UI.SpaceBetween>
                    <UI.Text size='base'>
                      <Translation name='to_go_per_guest' />
                    </UI.Text>

                    <SmartviewTextGroup>
                      <KpiRangeValue
                        name='food.to_go_per_guest'
                        lowerLimitName='indicators.items_per_guest_takeaway_lower_limit'
                        upperLimitName='indicators.items_per_guest_takeaway_upper_limit'
                      >
                        <UI.Text weight='medium' size='base' align='right' color='black'>
                          <Displays.Number name='food.to_go_per_guest' />
                        </UI.Text>
                      </KpiRangeValue>
                    </SmartviewTextGroup>
                  </UI.SpaceBetween>
                </SmartviewText>
              </SmartviewTextGroup>

            </div>
          </Model>

        </UI.Card>
      </Translator>
    </Widget>
  )
}
